module.exports = __webpack_public_path__ + "static/media/shop-category-bike.0afd9771.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shop-category-bike.svg
// module id = 198
// module chunks = 0